export default "__VITE_ASSET__CONlHXDy__"